function create_cart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountBubble = document.querySelector('.site-header-cart--count');
      const cartDrawer = document.querySelector('.cart_drawer');
      if (cartCountBubble) {
          cartCountBubble.setAttribute('data-header-cart-count', cart.item_count);
      }
      if(cart.item_count > 0){
        document.querySelector('.desktop_view_cart_number').style.display = 'block';
        document.querySelector('.site-header-cart--count').style.opacity = 1;
      }
      else{
        document.querySelector('.desktop_view_cart_number').style.display = 'none';
        document.querySelector('.site-header-cart--count').style.opacity = 0;
      }
      fetch('/')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const innerCartDrawer = doc.querySelector('.inner_cart_drawer');
          if (innerCartDrawer) {
            cartDrawer.innerHTML = innerCartDrawer.outerHTML;
          }
        });
    })
    .catch(error => console.error('Error:', error));
}
document.addEventListener('click', function(event) {
  if (event.target.closest('.site-header-cart--button')) {
    open_close_drawer();
    event.preventDefault();
  }
});

function open_close_drawer() {
  document.body.classList.add('open_cart');
  if (document.querySelectorAll('.overlay_widget').length < 1) {
    let overlay = document.createElement('div');
    overlay.className = 'overlay_widget';
    document.body.appendChild(overlay);
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('.overlay_widget') || event.target.closest('.close_drawer')) {
      document.body.classList.remove('open_cart');
      let overlay = document.querySelector('.overlay_widget');
      if (overlay) {
        overlay.remove();
      }
    }
  });
}

document.addEventListener('click', function(event) {
  var button = event.target.closest('.product-form--atc-button');  
  if (button) {
    var tempFormId = button.getAttribute('data-id');
    var actionWrapper = button.closest('.product-form__action-wrapper');
    if (actionWrapper) {
      var quantityInput = actionWrapper.querySelector('.quantity-selector__input');
      if (quantityInput) {
       var tempFormVal = quantityInput.value;
      }
    }
    else{
      var tempFormVal = 1;
    }
     button.classList.add('active_loader');
    addToCartProduct(tempFormId, tempFormVal);
    setTimeout(function() {
      open_close_drawer();
      button.classList.remove('active_loader');
      document.querySelector('.modal-close').click();
    }, 2000);
    event.preventDefault();
  }
});

function addToCartProduct(variantId, quantity) {
  const params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: `quantity=${quantity}&id=${variantId}`
  };

  fetch('/cart/add.js', params)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(lineItem => {
      create_cart();
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
}

async function update_qty(line, qty) {
  const params = new URLSearchParams({
    quantity: qty,
    line: line
  });

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      body: params.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const cart = await response.json();

    create_cart();
    if (qty > 0) {
      if (cart.items[line - 1].quantity !== qty) {
        console.log("You have only " + cart.items[line - 1].quantity + " quantity available in stock.");
      }
    }
  } catch (error) {
    console.error('Error updating quantity:', error);
    Shopify.api.onError(error);
  }
}


document.addEventListener('click', function(event) {
  if (event.target.closest('.QuantityBox .plus')) {
    var button = event.target.closest('.QuantityBox');
    var qtyInput = button.querySelector('.cart_qty_input');
    var currentVal = parseInt(qtyInput.value, 10);
    var line = button.getAttribute('data-line');
    if (currentVal >= 1) {
      button.querySelector('.minus_box').classList.remove('disabled');
    }
    if (!isNaN(currentVal)) {
      qtyInput.value = currentVal + 1;
      var qty = qtyInput.value;
      update_qty(line, qty);
    }
  }


  if (event.target.closest('.QuantityBox .minus')) {
    var button = event.target.closest('.QuantityBox');
    var qtyInput = button.querySelector('.cart_qty_input');
    var currentVal = parseInt(qtyInput.value, 10);
    var line = button.getAttribute('data-line');
    if (currentVal <= 1) {
      button.querySelector('.minus_box').classList.add('disabled');
    }
    if (!isNaN(currentVal) && currentVal > 0) {
      qtyInput.value = currentVal - 1;
      var qty = qtyInput.value;
      update_qty(line, qty);
    }
  }
});

document.addEventListener('click', function(event) {
  var target = event.target;
  if (target.closest('.remove_icon')) {
      const innerCartDrawer = document.querySelector('.inner_cart_drawer');
    innerCartDrawer.classList.add('active_loader');
    setTimeout(function() {
      innerCartDrawer.classList.remove('active_loader');
    }, 2000);
    var removeIcon = target.closest('.remove_icon');
    var line = removeIcon.getAttribute('data-line');
    var qty = 0;
    update_qty(line, qty);
    event.preventDefault();
  }
});

document.querySelectorAll('.cart_qty_input').forEach(function(input) {
        input.addEventListener('input', function() {
            var line = this.getAttribute('data-line');
            var qty = this.value;
            if (typeof update_qty === 'function') {
                update_qty(line, qty);
            } else {
                console.error('update_qty function is not defined.');
            }
        });
    });
